import { Pulsante } from '../../componenti';
import { ErroreApi } from '../../lib/api';
import { dataBreve } from '../../lib/formato';
import { Marchio, useIntestazione } from './Marchio';

/**
 * 6e — utenza disattivata.
 *
 * È l'unico esito che nega l'accesso: `utente.attivo = 0`, cioè disattivazione disposta
 * dall'amministratore. Iscrizione o porto d'armi scaduti non chiudono l'utenza — R-05
 * lascia consultare profilo, storico e prenotazioni.
 *
 * Vale per ogni porta d'ingresso: login ordinario (6a–6c) e rientro dopo la scadenza (6i).
 */

export interface Disattivazione {
  disattivata_il: string | null;
  ultimo_ingresso: string | null;
}

/** Riconosce l'errore e ne estrae i dettagli, o restituisce `null` se è un altro errore. */
export function comeDisattivazione(errore: unknown): Disattivazione | null {
  if (!(errore instanceof ErroreApi) || errore.codice !== 'utenza_disattivata') return null;
  return {
    disattivata_il: (errore.dettagli?.disattivata_il as string) ?? null,
    ultimo_ingresso: (errore.dettagli?.ultimo_ingresso as string) ?? null,
  };
}

export function UtenzaDisattivata({
  dati,
  onTorna,
}: {
  dati: Disattivazione;
  onTorna: () => void;
}) {
  const intestazione = useIntestazione();

  return (
    <div className="accesso accesso--colonna" data-densita="tattile">
      <Marchio intestazione={intestazione} />

      <div className="accesso__blocco-avviso">
        <div className="accesso__blocco-titolo">La tua utenza è disattivata</div>
        <div className="accesso__blocco-testo">
          Le credenziali sono corrette, ma l’amministratore ha disattivato l’utenza.
        </div>
        {dati.disattivata_il || dati.ultimo_ingresso ? (
          <div className="accesso__riquadro">
            {dati.disattivata_il ? (
              <div className="accesso__voce">
                <span>Disattivata il</span>
                <span className="dato">{dataBreve(dati.disattivata_il)}</span>
              </div>
            ) : null}
            {dati.ultimo_ingresso ? (
              <div className="accesso__voce">
                <span>Ultimo ingresso</span>
                <span className="dato">{dataBreve(dati.ultimo_ingresso)}</span>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>

      <div className="accesso__nota">
        <div style={{ fontWeight: 600, paddingBottom: 6 }}>Cosa fare</div>
        Solo la segreteria può riattivare l’utenza. Chiedi a loro il motivo.
      </div>

      <Pulsante variante="secondario" largo grande onClick={onTorna}>
        Torna al login
      </Pulsante>
    </div>
  );
}
